import { RAQuestionnaire } from '../../models';

const questionData: RAQuestionnaire = {
  questions: [{
    id: 1,
    text: 'Compared to others, how do you rate your willingness to take financial risks?',
    answers: [{
      id: 1,
      text: 'Extremely low risk taker'
    },
    {
      id: 2,
      text: 'Very low risk taker'
    },
    {
      id: 3,
      text: 'Low risk taker'
    },
    {
      id: 4,
      text: 'Average risk taker'
    },
    {
      id: 5,
      text: 'High risk taker'
    },
    {
      id: 6,
      text: 'Very high risk taker'
    },
    {
      id: 7,
      text: 'Extremely high risk taker'
    }
    ]
  },
  {
    id: 2,
    text: 'How easily do you adapt when things go wrong financially?',
    answers: [{
      id: 1,
      text: 'Very uneasily'
    },
    {
      id: 2,
      text: 'Somewhat uneasily'
    },
    {
      id: 3,
      text: 'Somewhat easily'
    },
    {
      id: 4,
      text: 'Very easily'
    }
    ]
  },
  {
    id: 3,
    text: 'When you think of the word \"risk\" in a financial context, which of the following words comes to mind first?',
    answers: [{
      id: 1,
      text: 'Danger'
    },
    {
      id: 2,
      text: 'Uncertainty'
    },
    {
      id: 3,
      text: 'Opportunity'
    },
    {
      id: 4,
      text: 'Thrill'
    }
    ]
  }
  ]
};

export default questionData;